import { doc, updateDoc } from "firebase/firestore";
import { forArrayLength } from "../misc/helperfuncs";
import { getObjectFromFirestore } from "./fireFuncs";
import db from "./fireInit";

const saveFocus = (player, focusId) => {
  console.log("FIREFUNC saveFocus");
  const playerRef = doc(db, "players", player.uid);
  if (player.active.focus) {
    const previousFocus = { ...player.active.focus, ended: Date.now() };
    updateDoc(playerRef, {
      "history.focuses": [...player.history.focuses, previousFocus],
    });
  }
  const newFocus = {
    id: focusId,
    start: Date.now(),
    activeGoal: player?.active.goal?.id ?? null,
    activeActivity: player?.active.box
      ? { id: player.active.box.id, type: player.active.box.type }
      : null,
    activeMood: player?.active.mood?.mood ?? null,
  };

  updateDoc(playerRef, { "active.focus": newFocus });
};

function getAllObjects(
  getObject,
  type,
  object,
  id,
  addGeneralObjects,
  getPluralType,
  onObjectsCollected
) {
  function onObjectRetrieved(doc) {
    const objects = {
      general: doc,
      open: getObject("open", getPluralType(type), doc.id) ?? null,
      saved: getObject("saved", getPluralType(type), doc.id) ?? null,
    };
    onObjectsCollected(objects);
  }
  if (object) onObjectRetrieved(object);
  else {
    const generalObject = getObject("general", getPluralType(type), id);

    if (generalObject) onObjectRetrieved(generalObject);
    else
      getObjectFromFirestore(
        type,
        id,
        addGeneralObjects,
        getPluralType,
        onObjectRetrieved
      );
  }
}

function updatePlayerArrays(uid, collection, pluralType, newArray) {
  const docRef = doc(db, `players/${uid}/${collection}`, pluralType);
  updateDoc(docRef, { array: newArray });
}

function handleNewActiveGoal(player, activeObject) {}

function addRemoveBoxType(player, boxType, add) {
  const boxTypes = { ...player.boxTypes };
  if (add) boxTypes[boxType.names.plural] = boxType;
  else delete boxTypes[boxType.names.plural];
  const userRef = doc(db, "players", player.uid);
  updateDoc(userRef, { boxTypes: boxTypes });
}

function storeBoxTypeInStorage(boxType) {
  const boxTypes = JSON.parse(localStorage.getItem("boxTypes")) ?? {};
  boxTypes[boxType.names.plural] = boxType;
  localStorage.setItem("boxTypes", JSON.stringify(boxTypes));
}

function updateBoxTypesInStorage(boxTypes) {
  localStorage.setItem("boxTypes", JSON.stringify(boxTypes));
}

export {
  updateBoxTypesInStorage,
  storeBoxTypeInStorage,
  getAllObjects,
  saveFocus,
  updatePlayerArrays,
  handleNewActiveGoal,
  addRemoveBoxType,
};
